import { useEffect } from "react";
import { Form, Row, Col } from "antd";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledDatePicker from "../../components/Backoffice/ControlledDatePicker";
import ControlledRadio from "../../components/Backoffice/ControlledRadio";
import ControlledTextArea from "../../components/ControlledTextArea";
import ControlledSelect from "../../components/Backoffice/ControlledSelectV1";

const AddLabSampleReceptionForm = ({
  // options,
  control,
  watch,
  errors,
  setValue,
  disableFields
}) => {
  const currentDate = new Date();
  const additionalSampleNeeded = watch("additionalSampleNeeded");

  useEffect(() => {
    if (additionalSampleNeeded === "No")
      setValue("additionalSampleReasons", "");
  }, [
    additionalSampleNeeded,
  ]);

  return (
    <Form colon={false} layout="vertical">
      <Row gutter={24}>
        <Col span={12}>
          <ControlledDatePicker
            required
            control={control}
            format="YYYY-MM-DD HH:mm:ss"
            showTime={true}
            name="sampleReceivedDate"
            label="Sample Received Date and Time"
            errors={errors}
            maximum={new Date(currentDate.getTime())}
            disabled={disableFields}
          />
        </Col>
        <Col span={12}>
          <ControlledSelect
            required
            control={control}
            name="samplePhysicalCondition"
            label="Sample Physical Condition"
            options={[
              { label: "Damaged", value: "Damaged" },
              { label: "Fit for analysis", value: "Fit for analysis" },
            ]}
            errors={errors}
            fullLabelWidth={true}
            disabled={disableFields}
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <ControlledInput
            required
            control={control}
            name="sampleSealNumber"
            label="Sample Seal Number"
            errors={errors}
            fullLabelWidth={true}
            disabled={disableFields}
          />
        </Col>
        <Col span={12}>
          <ControlledSelect
            required
            control={control}
            name="conditionOfSeal"
            label="Condition Of Seal"
            options={[
              { label: "Intact", value: "Intact" },
              { label: "Tempered/Broken", value: "Tempered/Broken" },
            ]}
            errors={errors}
            fullLabelWidth={true}
            disabled={disableFields}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <ControlledRadio
            required
            control={control}
            name="additionalSampleNeeded"
            label="Additional Sample Needed"
            errors={errors}
            options={[
              {
                value: "Yes",
                label: "Yes",
              },
              {
                value: "No",
                label: "No",
              },
            ]}
            disabled={disableFields}
          />
        </Col>
        {additionalSampleNeeded === "Yes" && (
          <Col span={12}>
            <ControlledTextArea
              required
              control={control}
              name="additionalSampleReasons"
              label="Reason for additional sample"
              errors={errors}
              disabled={disableFields}
            />
          </Col>
        )}
      </Row>

       <Row gutter={24}>
        <Col span={12}>
          <ControlledInput
            required
            control={control}
            name="sampleRegistrationNumber"
            label="Sample Registration Number"
            errors={errors}
            fullLabelWidth={true}
            disabled={disableFields}
          />
        </Col>
        <Col span={12}>
          <ControlledDatePicker
            required
            control={control}
            name="expectedDateOfCompletion"
            label="Expected Completion Date"
            errors={errors}
            minimum={new Date(currentDate.getTime())}
            disabled={disableFields}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default AddLabSampleReceptionForm;
